import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { LineStatusRemoteDto } from '../../../../../generated/signalR/line-status-remote-dto';
import { LineStatusType } from '../../../../samwebDescription/samweb/contactStatus/lineStatusType';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { LineStatusValuesUpdated } from './line-status.actions';
import { Injectable } from '@angular/core';

export interface LineStatusStateModel {
   lineStates: { [instanceId: string]: LineStatusRemoteDto };
}

@State<LineStatusStateModel>({
   name: 'lineStatus',
   defaults: {
      lineStates: {},
   },
})
@Injectable()
export class LineStatusState {
   @Selector([LineStatusState])
   public static getAllAvailableLineStates(state: LineStatusStateModel): { [p: string]: LineStatusRemoteDto } {
      return state.lineStates;
   }

   private static getLineStateRawDataSelector(tr87Number: string, orgnum: string) {
      return createSelector([LineStatusState.getAllAvailableLineStates], (allLineStates: { [p: string]: LineStatusRemoteDto }) => {
         const lineState = allLineStates[tr87Number];
         if (lineState) {
            return lineState;
         }
         return allLineStates[orgnum];
      });
   }

   public static getLineStateSelector(tr87Number: string, orgnum: string) {
      return createSelector([LineStatusState.getLineStateRawDataSelector(tr87Number, orgnum)], (lineState: LineStatusRemoteDto) => {
         const lineStatus: LineStatusType = lineState ? LineStatusType.getPresenceStatusBySamwinValue(lineState.status) : LineStatusType.None;
         return {
            lineState: lineState,
            lineStatus: lineStatus,
         };
      });
   }

   @Action(LineStatusValuesUpdated)
   @ImmutableContext()
   public contactStatesUpdated(ctx: StateContext<LineStatusStateModel>, action: LineStatusValuesUpdated) {
      ctx.setState((state: LineStatusStateModel) => {
         action.lineStates.forEach((lineStatus) => (state.lineStates[lineStatus.extensionNumber] = lineStatus));
         return state;
      });
   }
}
